// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lZbHJkV5P4GjmJ {
  visibility: hidden;
}
.X__la2b2FznhkD {
  max-width: 200px;
  height: 115px;
  background-color: var(--ds-background-neutral, #091e420f);
  vertical-align: middle;
}
.X__la2b2FznhkD .WG4Puou8oxwgLv {
  width: 150px;
  margin-right: auto;
  margin-left: auto;
}
.X__la2b2FznhkD .Qs3WZdVlh1Y_AZ {
  color: var(--ds-text-subtle, #44546f);
}
.X__la2b2FznhkD .Tg2cgBQQY8oLH8 {
  margin-top: var(--ds-space-300, 24px);
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  letter-spacing: -0.006em;
  line-height: 20px;
  font-weight: var(--ds-font-weight-semibold, 600);
}
.GLSPOdhezqpoFe {
  text-align: center;
}
.M2EsVlfABQ7CGB {
  margin-top: var(--ds-space-300, 24px);
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  letter-spacing: -0.006em;
  line-height: 20px;
  font-weight: var(--ds-font-weight-semibold, 600);
}
`, ""]);
// Exports
export var noCell = `lZbHJkV5P4GjmJ`;
export var cell = `X__la2b2FznhkD`;
export var text = `WG4Puou8oxwgLv`;
export var total = `Qs3WZdVlh1Y_AZ`;
export var price = `Tg2cgBQQY8oLH8`;
export var contactBtn = `GLSPOdhezqpoFe`;
export var cellHeader = `M2EsVlfABQ7CGB`;
export default ___CSS_LOADER_EXPORT___;
